import types from "../index";

export const defaultState = {
    cart: [],
}

function cartReducer(state, action) {
    switch (action.type) {
        case types.CART_ADD_TO_CART: {
            if (state.cart.some(cartItem => cartItem.id === action.item.id)) {
                if(action.item.countable) {
                    let _cart = state.cart.map((cartItem) => {
                        if (cartItem.id === action.item.id)
                            return {
                                ...cartItem,
                                amount: cartItem.amount + 1,
                            }
                        else return {...cartItem}
                    });
                    return {
                        ...state,
                        cart: [..._cart]
                    }
                }
            } else {
                return {
                    ...state,
                    cart: [...state.cart, action.item]
                }
            }
        }

        case types.CART_REMOVE_FROM_CART: {
            let _cart = state.cart.map((cartItem) => {
                if (cartItem.id === action.id) {
                    return {
                        ...cartItem,
                        amount: cartItem.amount - 1,
                    }
                } else
                    return {...cartItem}
            });

            let finalCart = _cart.filter(cartItem => cartItem.amount > 0);

            return {
                ...state,
                cart: [...finalCart],
            }
        }

        default:
            throw new Error("Unhandled action type");
    }
}

export default cartReducer;
